export const APARMENTS = 'APARMENTS';
export const APARMENTS_SUCCESS = 'APARMENTS_SUCCESS';
export const APARMENTS_ERROR = 'APARMENTS_ERROR';

export const ADD_APARMENT = 'ADD_APARMENT';
export const ADD_APARMENT_SUCCESS = 'ADD_APARMENT_SUCCESS';
export const ADD_APARMENT_ERROR = 'ADD_APARMENT_ERROR';

export const UPDATE_APARMENT = 'UPDATE_APARMENT';
export const UPDATE_APARMENT_SUCCESS = 'UPDATE_APARMENT_SUCCESS';
export const UPDATE_APARMENT_ERROR = 'UPDATE_APARMENT_ERROR';

export const DELETE_APARMENT = 'DELETE_APARMENT';
export const DELETE_APARMENT_SUCCESS= 'DELETE_APARMENT_SUCCESS';
export const DELETE_APARMENT_ERROR ='DELETE_APARMENT_ERROR';

